import {
  Box,
  Button,
  Checkbox,
  Dialog,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { ReactComponent as Sound } from 'assets/svg/Sound.svg';
import 'index.css';
import React, { useState } from 'react';
import { Warning } from 'component/BuyersMarketplace/MakeOffers';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { stageTwoView } from 'api/apiService';
import Loading from '../.././assets/images/loading.png';
import {
  poppins300,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import Swal from 'sweetalert2';

const ConfirmingParticipationStageTwo = ({
  openConfirmingPopup,
  setOpenConfirmingPopup,
  getBuyerIndividualValue,
  groupIt,
  groupCall,

  setTotalAmount,
  setSelectedItems,
  setOfferExp,
  setIsBestOffer,
  setIsAutoOffer,
  setMaximumOffer,
  setOfferIncreament,
  setSubtoAddSelected,
  setSelectedConditionCodes,
  openCard,
  setOpenCard,
  fromMakeOffer,
}) => {
  const [stageLoader, setStageLoader] = useState(false);
  const [acceptterms, setAcceptterms] = useState(false);
  const params = useParams();
  const theme = useTheme();

  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));

  const stageTwoViewFunc = async () => {
    setStageLoader(true);

    try {
      const input = {
        propertyId: params?.propertyId,
        status: 'Accepted',
        isAccept: 1,
        isAcceptancePopup: 1,
      };

      const res = await stageTwoView(input);

      const isSuccess = res?.status === 1;

      if (isSuccess) {
        groupCall();
        groupIt();
      }

      Swal.fire({
        title: isSuccess ? res?.heading : 'Error',
        text: res?.message || 'Something went wrong',
        icon: isSuccess ? 'success' : 'error',
        confirmButtonText: 'Close',
      });
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text: 'Something went wrong. Please try again.',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setStageLoader(false);
      setOpenConfirmingPopup(false);
    }
  };

  return (
    <Dialog
      open={openConfirmingPopup}
      onClose={() => setOpenConfirmingPopup(!openConfirmingPopup)}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          minWidth: matches700 ? '95%' : '700px',
        },
      }}
    >
      <Grid
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid
          container
          sx={{
            height: '775px',
            minWidth: matchessm ? '95%' : '400px',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '20px 20px' : '30px',
            border: '1px solid #D9D9D9',
            backgroundColor: '#FFFFFF',
          }}
        >
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '12px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            <Grid
              item
              display={'flex'}
              alignItems={'center'}
              padding={'10px 0px'}
            >
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  paddingLeft: '12px',
                  color: '#000000',
                }}
              >
                Confirming Participation - Final Timer Stage 2
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  paddingTop: '8px',
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  lineHeight: '28px',
                  justifyItems: 'self-end',
                }}
              >
                You are about to participate in Final Stage Timer 2. You are now
                offering to buy the property with all Contract of Sale terms
                being already negotiated.
              </Typography>
              <br />
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px!important',
                  color: '#4CA4D6',
                  justifyItems: 'self-end',
                  marginLeft: '-2px',
                }}
              >
                (View more about Final Timer Stage 2)
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid sx={{ width: '115%' }}>
              <Typography
                sx={{
                  border: '1px solid #D9D9D9',
                  display: 'flex',
                  flexDirection: 'row',
                  marginTop: matchessm ? '10px' : '25px',
                  justifyItems: 'self-end',
                  marginLeft: '-30px',
                  marginRight: matchessm ? '-20px' : '-30px',
                }}
              ></Typography>
            </Grid>
          </Grid>
          <Grid
            sx={{
              marginTop: matchessm ? '0px' : '20px',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '16px' : '24px!important',
                fontWeight: 400,
                color: '#000000',
              }}
            >
              Terms and Conditions
            </Typography>
          </Grid>
          <Grid item display={'flex'} marginTop={matchessm ? '0' : '10px'}>
            <Grid>
              <Checkbox
                checked={acceptterms}
                onClick={(e) => setAcceptterms(!acceptterms)}
                sx={{
                  width: matchessm ? '10px' : '17px',
                  height: matchessm ? '10px' : '17px',
                  '&.Mui-checked': {
                    color: '#C4C4C4',
                    backgroundColor: 'black',
                  },
                }}
              />
            </Grid>
            <Typography
              onClick={() => setAcceptterms(!acceptterms)}
              sx={{
                ...poppins300,
                fontSize: matchessm ? '10px' : '14px',
                paddingLeft: matchessm ? '10px' : '21px',
                color: '#666666',
                cursor: 'pointer',
              }}
            >
              I acknowledge and agree to the Terms and Conditions set out by
              retreX and the selling agent.
            </Typography>
          </Grid>
          <Typography
            sx={{
              ...poppins300,
              fontSize: matchessm ? '10px' : '14px',
              paddingLeft: matchessm ? '28px' : '43px',
              color: '#666666',
            }}
          >
            If I am the highest offer at the end of the Final Stage Timer 2, I
            accept responsibility in proceeding with the purchase of this
            property.
          </Typography>
          <Grid
            container
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Grid
              container
              sx={{
                width: '601px',
                height: '141px',
                border: '1px solid #965CF0',
                background: '#FFFFFF',
                borderRadius: '10px',
                marginTop: matchessm ? '-30px' : '26px',
                alignItems: 'center',
              }}
            >
              <Grid
                item
                display={'flex'}
                alignItems={'center'}
                marginLeft={'10px'}
              >
                <Sound
                  width={matchessm ? 44 : 64}
                  height={matchessm ? 28 : 48}
                />
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: matchessm ? '16px' : '20px',
                    paddingLeft: '12px',
                    color: '#112347',
                  }}
                >
                  Important
                </Typography>
              </Grid>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '7px',
                  justifyContent: 'center',
                }}
              >
                <Grid>
                  <Box
                    sx={{
                      ...poppins400,
                      fontSize: matchessm ? '10px' : '14px',
                      margin: '2px 10px',
                      color: '#666666',
                    }}
                  >
                    This message will not be shown again when making an offer in
                    Final Timer Stage 2.
                  </Box>
                </Grid>
                <Grid>
                  <Typography
                    sx={{
                      ...poppins300,
                      fontSize: matchessm ? '10px' : '14px',
                      color: '#4CA4D6',
                    }}
                  >
                    (View more about Final Timer Stage 2)
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          {fromMakeOffer ? (
            <>
              <Grid
                container
                gap={2}
                marginTop={matchessm ? '7px' : '19px'}
                justifyContent={'end'}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => {
                      setTotalAmount(0);
                      setAcceptterms(false);
                      setSelectedItems([]);
                      setOfferExp(null);
                      setIsBestOffer(false);
                      setIsAutoOffer(false);
                      setMaximumOffer('');
                      setOfferIncreament('');
                      setSubtoAddSelected(false);
                      setSelectedConditionCodes([]);
                      setOpenConfirmingPopup(!openConfirmingPopup);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    // variant="outlined"
                    type="submit"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: acceptterms ? '#FFFFFF' : '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: acceptterms ? '#4CA4D6' : '#D9D9D9',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                    onClick={() => setOpenCard(!openCard)}
                  >
                    &nbsp;Confirm&nbsp;
                  </Button>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <Grid
                container
                gap={2}
                marginTop={matchessm ? '7px' : '19px'}
                justifyContent={'end'}
              >
                <Grid item>
                  <Button
                    variant="outlined"
                    onClick={() => setOpenConfirmingPopup(false)}
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'none',
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Stack display="flex" flexDirection="row" alignItems="center">
                    <Button
                      disabled={!acceptterms || stageLoader}
                      type="submit"
                      onClick={stageTwoViewFunc}
                      style={{
                        padding: matchessm ? '6px 23px' : '10px 39px',
                        width: '100%',
                        height: matchessm ? '35px' : '41px',
                        fontSize: matchessm ? '12px' : '14px',
                        color:
                          acceptterms && !stageLoader ? '#FFFFFF' : '#666666',
                        fontWeight: '400',
                        fontFamily: 'Poppins',
                        background:
                          acceptterms && !stageLoader ? '#4CA4D6' : '#D9D9D9',
                        borderRadius: '5px',
                        textTransform: 'none',
                        cursor:
                          acceptterms && !stageLoader
                            ? 'pointer'
                            : 'not-allowed',
                      }}
                    >
                      Confirm
                    </Button>

                    {stageLoader && (
                      <img
                        alt="Loading"
                        src={Loading}
                        className="loaderImage"
                        style={{
                          height: '40px',
                          width: '40px',
                          marginLeft: '8px',
                        }}
                      />
                    )}
                  </Stack>
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ConfirmingParticipationStageTwo;
